import { PaymentService } from '@app/_services/payment.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonUtility } from '@app/_modules/commonUtility';



@Component({  templateUrl: './pay-student.component.html' })
export class PayStudentComponent implements OnInit {

  form: FormGroup;
    loading = false;
    submitted = false;
    initialCap: any;
    commonUtility:CommonUtility;
    resStatusCode;
    feeData:any;
    studentData:any;
  constructor( private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private paymentService:PaymentService,
    ) {
      this.commonUtility = paymentService.commonUtility;
    }


  ngOnInit() {
    this.form = this.formBuilder.group({
      registrationNo: ['', [Validators.required, Validators.pattern("^[0-9]*$"),Validators.minLength(1)]],
        captcha: ['', Validators.required]
    });

    this.Cap();
  }

  ValidCaptcha(){
    let str1=this.initialCap
    let str2=this.form.get('captcha').value;
    if(str2.toUpperCase()!="") {
    if(str1 == str2.toUpperCase()){
      this.form.controls['captcha'].setErrors(null);
      return true;
    }else{
      this.form.controls['captcha'].setErrors({'incorrectcaptcha': true});
      return false;
    }
    }
    else {
      this.commonUtility.alertMsg('Please try again invalid Captcha','',false);
    }
  }

  Cap() {
    let alpha = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
     var apl1 = alpha[Math.floor(Math.random() * 36)];
     var apl2 = alpha[Math.floor(Math.random() * 36)];
     var apl3 = alpha[Math.floor(Math.random() * 36)];
     var apl4 = alpha[Math.floor(Math.random() * 36)];
     var apl5 = alpha[Math.floor(Math.random() * 36)];
     var apl6 = alpha[Math.floor(Math.random() * 36)];
     this.initialCap = apl1 + apl2 + apl3 + apl4 + apl5 + apl6;

     }
     showForm (ele){
      //this.registeras =ele;
      console.log(ele);
  }


// convenience getter for easy access to form fields
get f() { return this.form.controls; }
fetchStudentFeeDetail()
{

}

onSubmit() {
  var routeUrl;
  this.submitted = true;

  // stop here if form is invalid
  if (this.form.invalid || (!this.ValidCaptcha())) {
      return;
  }

  this.loading =true;
  var req ={
      "registrationNo":'RM-'+this.form.controls.registrationNo.value,
      "status":"0"
      };
      routeUrl = 'payment/pay-details';
  this.paymentService.fetchByContractNoandPanNo(req).subscribe(res=>{
    console.log('res : '+JSON.stringify(res));
    if(res.body.statusCode === '00000'){

      this.resStatusCode = res.body.statusCode;
      this.feeData = res.body.data.feeDetail;
      this.studentData = res.body.data.studentDetail;
      var createdDate = this.feeData?.createdDate.split('T')[0];
      var dueDate = this.feeData?.dueDate.trim();

      var day = dueDate.split('-')[2];
      var month=dueDate.split('-')[1]-1;
      var year=dueDate.split('-')[0];
      var dueDateValue = new Date(year,month,day);  // 2009-11-10
      console.log(dueDate);
      console.log('date1 '+dueDateValue);
      console.log('month '+month);
      var monthText1 = dueDateValue.toLocaleString('default', { month: 'long' });
      console.log('dueDate : '+JSON.stringify( (day+' '+monthText1+' '+year)));
      this.router.navigate([routeUrl], { state: {
         feeData:this.feeData,studentData :  this.studentData,dueDate:(day+' '+monthText1+' '+year)
         }});
    }else if( res.body.statusCode === '100001'){
      this.router.navigate([routeUrl], { state: {
        message:'No Payment Found'

      }});
    }
    else{
        this.commonUtility.alertMsg(res.body.statusDesc,'',false);
      }
      this.Cap();
      this.loading =false;
  },(error)=>{
      this.Cap();
      this.commonUtility.alertMsg('Please try again Failed to Fetch details ','',false);
      this.form.controls.registrationNo.setValue('');
      this.form.controls.captcha.setValue('');
      this.loading =false;
    });

}
}
